import { useMemo } from 'react';
import { useCalibrationRuntimeByGuid } from '@features/calibration/hooks/useCalibrationRuntime/useCalibrationRuntimeRead';
import {
  useWorkOrderDetailByGlobalId,
  type WorkOrderDetailSummary
} from '@api/bff/workOrders/useWorkOrderDetailByGlobalId';

import type { CalibrationRuntimeData } from '@features/calibration/hooks/useCalibrationRuntime/types';
import type { DcRuntimeViewModel } from '@api/bff/openapi/models';

type HistoryPageState = {
  calibrationRuntime: DcRuntimeViewModel | undefined;
  calibrationData: CalibrationRuntimeData | null;
  workOrderDetail: WorkOrderDetailSummary | undefined;
  isLoading: boolean;
  error: Error | null;
  isCompleted: boolean;
  hasData: boolean;
};

export const useHistoryPageState = (
  dcRuntimeId: string | undefined
): HistoryPageState => {
  const { calibrationRuntime, calibrationData, isLoading, error } =
    useCalibrationRuntimeByGuid(dcRuntimeId);

  const { data: workOrderDetail, isLoading: isLoadingDetail } =
    useWorkOrderDetailByGlobalId(calibrationRuntime?.woDetailGlobalId);

  const isCompleted = useMemo(() => {
    if (!calibrationData) return false;
    return (
      calibrationData.status?.calibration === 'complete' ||
      calibrationRuntime?.eventNum != null
    );
  }, [calibrationData, calibrationRuntime?.eventNum]);

  const hasData = calibrationData != null;

  return {
    calibrationRuntime,
    calibrationData,
    workOrderDetail,
    isLoading: isLoading || isLoadingDetail,
    error,
    isCompleted,
    hasData
  };
};
